import { DAPI_HOST } from '../../config/index';

const getCareerLeadsUrl = () => `${DAPI_HOST}/v1/career-leads`;

export { getCareerLeadsUrl };
